import classNames from 'classnames';
import { useScreenQuery } from 'playup-web-core';
import React from 'react';
import styled from 'styled-components';

const SlideNavigator = ({ currentIndex, onPress, length }: Props) => {
	const { isSmall } = useScreenQuery();

	const elements = React.useMemo(() => {
		const elArray: Array<number> = [];

		for (let i = 0; i < length; i++) elArray.push(i);

		return elArray;
	}, [length]);

	return (
		<StyledWrapper isSmall={isSmall}>
			{elements.map((index) => (
				<div onClick={() => onPress(index)} key={index} className={classNames(index === currentIndex && 'active')} />
			))}
		</StyledWrapper>
	);
};

export default SlideNavigator;

interface Props {
	currentIndex: number;
	onPress: (index: number) => void;
	length: number;
}

const StyledWrapper = styled.div<{ isSmall: boolean }>`
	display: flex;
	justify-content: center;
	margin-bottom: ${({ isSmall }) => (isSmall ? 18 : 20)}px;
	flex-wrap: wrap;

	div {
		border-radius: 100%;
		background-color: #cccccc;
		width: 8px;
		height: 8px;
		margin: 5px;
		cursor: pointer;
		transition: transform 400ms;

		&.active {
			background-color: #191d22;
			transform: scale(120%);
		}

		&:hover {
			opacity: 0.8;
		}
	}
`;
